import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import News from "@/pages/News";
import Contact from "@/pages/Contact";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const t = setTimeout(() => lenis?.scrollTo(el, { offset: -90 }), 150);
        return () => clearTimeout(t);
      }
    }
    lenis?.scrollTo(0, { immediate: true });
  }, [pathname, hash, lenis]);

  return null;
};

function App() {
  return (
    <ReactLenis root options={{ duration: 1.05, smoothWheel: true }}>
      <BrowserRouter>
        <ScrollManager />
        <div className="App flex min-h-screen flex-col bg-[#FBF6EC] text-[#1A222D]">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/events" element={<Events />} />
              <Route path="/news" element={<News />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
